import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { sendOtp } from "~/api";
import { ROUTES } from "~/router";
import { useRecaptcha } from "~/screens/Auth/hooks/useRecaptcha";
import { errorToast } from "~/ui/admin";

interface SendOtpVariables {
  email: string;
  searchParams: URLSearchParams;
}

export const useSendOtp = () => {
  const navigate = useNavigate();
  const { handleReCaptchaVerify } = useRecaptcha("send_otp");

  return useMutation({
    mutationFn: async ({ email }: SendOtpVariables) => {
      const reCaptchaToken = await handleReCaptchaVerify();
      if (!reCaptchaToken) throw new Error("reCAPTCHA verification failed");
      return sendOtp({ email, reCaptchaToken });
    },
    onSuccess: (_data, { email, searchParams }) => {
      navigate(`${ROUTES.codeValidation}?${searchParams.toString()}`, {
        state: { email },
      });
    },
    onError: (error) => {
      errorToast(error);
    },
  });
};
